export default {
  numbers: '' + 10,
  operations: 'times',
  decimals: false,
  generate () {
    // create questions if needed
  },
  getQuestion (answerCount) {
    let answers = []
    let sen = ''
    let oper = this.operations
    if (oper === 'mixed') {
      const op = Math.round(Math.random())
      if (op) {
        oper = 'times'
      } else {
        oper = 'divide'
      }
    }

    const targetNumberOptions = this.numbers.split(',')
    const targetNumber = parseInt(this.shuffleArray(targetNumberOptions)[0]) // the times table
    let num = Math.floor(Math.random() * 1000) + 1 // the start number
    if (this.decimals) {
      num = parseFloat((Math.floor(Math.random() * 1000000) / 1000).toFixed(4))
    }

    const otherNum = parseFloat((targetNumber * num).toFixed(4)) // product

    if (oper === 'times') {
      answers.push({ answer: otherNum, correct: true })
      const ord = Math.round(Math.random())
      if (ord === 1) {
        sen += num + ' × ' + targetNumber
      } else {
        sen += targetNumber + ' × ' + num
      }

      if (answerCount > 1) {
        let wrongAnswers = []
        for (let i = 0; i < targetNumber + otherNum + 12; i++) {
          if (i !== otherNum) {
            wrongAnswers.push(parseFloat('' + i + (this.decimals ? '.' + this.randomNumberString(3) : (Math.round(Math.random()) === 1 ? '0' : ''))))
          }
        }
        wrongAnswers = this.shuffleArray(wrongAnswers)
        for (let j = 0; j < answerCount - 1; j++) {
          if (j < 3) {
            answers.push({ answer: '' + wrongAnswers[j], correct: false })
          }
        }
        if (answers.length < answerCount) {
          if (targetNumber === 10) {
            answers.push({ answer: parseFloat('' + num * 100), correct: false })
            answers.push({ answer: parseFloat('' + num * 1000), correct: false })
          } else if (targetNumber === 100) {
            answers.push({ answer: parseFloat('' + num * 10), correct: false })
            answers.push({ answer: parseFloat('' + num * 1000), correct: false })
          } else if (targetNumber === 1000) {
            answers.push({ answer: parseFloat('' + num * 100), correct: false })
            answers.push({ answer: parseFloat('' + num * 10000), correct: false })
          }
        }
        answers = this.shuffleArray(answers)
      }
      return { question: sen, answers }
    } else { // divide
      answers.push({ answer: num, correct: true })
      sen = otherNum + ' ÷ ' + targetNumber
      // wrong answers
      if (answerCount > 1) {
        let wrongAnswers = []
        for (let i = 0; i <= num + 12; i++) {
          if (i !== num) {
            wrongAnswers.push(parseFloat('' + i + (this.decimals ? '.' + this.randomNumberString(3) : (Math.round(Math.random()) === 1 ? '0' : ''))))
          }
        }
        wrongAnswers = this.shuffleArray(wrongAnswers)
        for (let j = 0; j < answerCount - 1; j++) {
          if (j < 3) {
            answers.push({ answer: '' + wrongAnswers[j], correct: false })
          }
        }
        if (answers.length < answerCount) {
          if (targetNumber === 10) {
            answers.push({ answer: parseFloat('' + otherNum * 10), correct: false })
            if (this.decimals) {
              answers.push({ answer: parseFloat('' + otherNum / 100), correct: false })
            } else {
              answers.push({ answer: parseFloat('' + otherNum), correct: false })
            }
          } else if (targetNumber === 100) {
            answers.push({ answer: parseFloat('' + otherNum / 10), correct: false })
            if (this.decimals) {
              answers.push({ answer: parseFloat('' + otherNum / 1000), correct: false })
            } else {
              answers.push({ answer: parseFloat('' + otherNum * 10), correct: false })
            }
          } else if (targetNumber === 1000) {
            answers.push({ answer: parseFloat('' + otherNum / 100), correct: false })
            if (this.decimals) {
              answers.push({ answer: parseFloat('' + otherNum / 10000), correct: false })
            } else {
              answers.push({ answer: parseFloat('' + otherNum / 10), correct: false })
            }
          }
        }
        answers = this.shuffleArray(answers)
      }
      return { question: sen, answers }
    }
  },
  shuffleArray (array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      const temp = array[i]
      array[i] = array[j]
      array[j] = temp
    }
    return array
  },
  randomNumberString (length) {
    let n = Math.random()
    n = Math.round(n * 1000)
    return n
  }
}
